import { makeSeznamTracker } from "../../shared/integrations/Seznam/seznam-tracker.js";
export const NOOP_TRACKER = {
    track: async () => { },
};
/** Fans an event out to every provider; one failing provider never affects the others. */
export function makeCompositeTracker(trackers) {
    return {
        async track(event) {
            await Promise.all(trackers.map(async (tracker) => {
                try {
                    await tracker.track(event); // will throw on both sync and async implementation
                }
                catch {
                    // ignore
                }
            }));
        },
    };
}
/**
 * Builds the set of trackers enabled by the runtime config.
 * Future providers (Meta, GTM, …) get added here — callers stay unaware of them.
 */
export function makeAnalyticsTracker(config, win) {
    const trackers = [];
    const conversionId = config.analyticsEvents?.seznamConversion ?? null;
    if (config.seznamRtgId || conversionId != null) {
        trackers.push(makeSeznamTracker({
            rtgId: config.seznamRtgId,
            conversionId,
            win,
        }));
    }
    return trackers.length ? makeCompositeTracker(trackers) : NOOP_TRACKER;
}
